import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import useGetData from "../api/useGetData";
import {
  setBookingSettings,
  setServicesRequest,
  setSupportLink,
  setVehiclesRequest,
} from "../redux/slices/cachedRequestsSlice";

/**
 * A hook that sends all the requests that need to be sent only one time all of them at once and stores them in redux store.
 * It also resends the these requests when the language changes as the response depends on the selected language
 */

const useCacheRequests = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("global");
  const {
    data: servicesData,
    getData: getServicesData,
    loading: loadingServices,
  } = useGetData({
    route: "api/method/airport_transport.api.bookings.get_services",
    params: {},
  });

  const {
    data: vehicleTypeData,
    getData: getVeichelTypeData,
    loading: loadingVehicles,
  } = useGetData({
    route: "api/method/airport_transport.api.bookings.get_vehicles",
    params: {},
  });

  const { data: supportLinkData } = useGetData({
    route: "api/method/airport_transport.api.bookings.get_support_link",
    params: {},
  });

  const { data: bookingSettings } = useGetData({
    route: "api/method/airport_transport.api.bookings.get_settings",
  });

  useEffect(() => {
    if (vehicleTypeData) {
      dispatch(setVehiclesRequest(vehicleTypeData));
    }
  }, [vehicleTypeData]);

  useEffect(() => {
    if (servicesData) {
      dispatch(setServicesRequest(servicesData));
    }
  }, [servicesData]);

  useEffect(() => {
    if (!loadingServices && !loadingVehicles) {
      getServicesData({
        params: {},
      });
      getVeichelTypeData({
        params: {},
      });
    }
  }, [i18n, t]);

  useEffect(() => {
    if (supportLinkData) {
      dispatch(setSupportLink(supportLinkData));
    }
  }, [supportLinkData]);

  useEffect(() => {
    if (bookingSettings) {
      dispatch(setBookingSettings(bookingSettings));
    }
  }, [bookingSettings]);
};

export default useCacheRequests;
